<button nz-button (click)="visible = !visible" *ngIf="area === 1">
  <i class="fal fa-comments-alt"></i>
  <span class="xs-h s-h">{{"Activities" | locale}}</span>
</button>
<nz-drawer [nzVisible]="visible" (nzOnClose)="visible = !visible" [nzTitle]="'Activities' | locale"
  nzWrapClassName="drawer-size-3x">
  <app-communication *ngIf="visible" nzGhost="true" [moduleId]="moduleId" [recordId]="recordId"
    [recordModel]="recordModel">
  </app-communication>
</nz-drawer>
